import CategoryCard from "@/Components/Course/CategoryCard";
import { getImage } from "@/constants";
import { SliderCustom } from "@/helpers/general";
import { useAppSelector } from "@/redux/hooks";
import { RootState } from "@/redux/store";
import { usePage } from "@inertiajs/react";
import { map } from "lodash";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRef } from "react";
import Slider from "react-slick";

// Each tile maps to the Instagram handle printed on the image — order matches groups/{i}.jpg.
const partners: { handle: string; url: string }[] = [
    { handle: "aum_guides",     url: "https://www.instagram.com/aum_guides?igsh=NHo4cnQ3d3YyaWdr" },
    { handle: "ksa_helps",      url: "https://www.instagram.com/ksa_helps?igsh=cTdxNDV4ZGt4a3Vv" },
    { handle: "jordan.helps",   url: "https://www.instagram.com/jordan.helps?igsh=MTJ5ZjA0YWs1bGZ2dA==" },
    { handle: "egypt.helps",    url: "https://www.instagram.com/egypt.helps/" },
    { handle: "uae.helps",      url: "https://www.instagram.com/uae.helps?igsh=MTVzeDg5ano0ZnJ0bQ==" },
    { handle: "seniors_canada", url: "https://www.instagram.com/seniors_canada?igsh=cjRreTYxZnN0bnBv" },
    { handle: "seniorhelp.usa", url: "https://www.instagram.com/seniorhelp.usa?igsh=MTk0b3BmMnVpc252cQ==" },
    { handle: "seniorhelp.uk",  url: "https://www.instagram.com/seniorhelp.uk?igsh=MWs4ZWNscGN3ZnRyaA==" },
    { handle: "senior_helps",   url: "https://www.instagram.com/senior_helps?igsh=ZG4xMHNxODh5cnVx" },
    { handle: "kunivcgs",       url: "https://www.instagram.com/kunivcgs?igsh=b2hub3VweGplZ282" },
    { handle: "kuniv_news",     url: "https://www.instagram.com/kuniv_news?igsh=Y2tkNDNyZnhzcnE4" },
    { handle: "kuniv_jobs",     url: "https://www.instagram.com/kuniv_jobs?igsh=MTB4MXMyeXF2Y3FvNw==" },
    { handle: "aasu_news",      url: "https://www.instagram.com/aasu_news?igsh=NzBuenhsamUxc3l1" },
    { handle: "paaet_support",  url: "https://www.instagram.com/paaet_support?igsh=MTgzNWRybXFxc2Y4Yw==" },
    { handle: "aiu_helps",      url: "https://www.instagram.com/aiu_helps?igsh=MWprcnl1Mjc1M3NkZw==" },
];

export default function () {
    const { isRTL } = useAppSelector((state: RootState) => state.locale);
    const {
        ziggy: { query },
    }: any = usePage().props;
    const refSlider = useRef<Slider | null>(null);

    var settings = {
        rtl: isRTL,
        dots: false,
        // dotsClass: "slick-dots block lg:hidden",
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        adaptiveHeight: true,
        swipeToSlide: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        initialSlide: 6,
        // focusOnSelect: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 2500,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    initialSlide: 6,
                },
            },
            {
                breakpoint: 1450,
                settings: {
                    slidesToShow: 6,
                    initialSlide: 6,
                    slidesToScroll: 6,
                },
            },
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 4,
                    initialSlide: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    initialSlide: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 2,
                    initialSlide: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    };

    const RenderArrows = () => {
        return (
            <div className="relative z-50 hidden lg:flex w-[110%] md:w-[108%] xl:w-[105%] h-0  justify-between items-center m-auto -bottom-10 rtl:-right-10 ltr:-left-10">
                <ChevronLeft
                    onClick={() => refSlider?.current?.slickPrev()}
                    className="relative rtl:rotate-180 ltr:right-2 rtl:left-2 h-8 w-8 text-gray-700 border border-gray-200 bg-gray-100 hover:bg-gray-200 rounded-xl p-2"
                />
                <ChevronRight
                    onClick={() => refSlider?.current?.slickNext()}
                    className="relative rtl:rotate-180 ltr:left-2 rtl:right-2 h-8 w-8 text-gray-700 border border-gray-200 bg-gray-100 hover:bg-gray-200 rounded-xl p-2"
                />
            </div>
        );
    };

    return (
        <div className="px-8">
            <RenderArrows />
            <SliderCustom {...settings} ref={refSlider}>
                {map(partners, (p, i) => (
                    <a
                        key={i}
                        href={p.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Instagram: ${p.handle}`}
                        title={`@${p.handle}`}
                        className="block cursor-pointer transition-transform duration-200 hover:scale-105 focus:scale-105 focus:outline-none"
                    >
                        <img
                            loading="lazy"
                            src={getImage(`groups/${i}.jpg`)}
                            alt={`Instagram @${p.handle}`}
                            className="w-20 h-20 md:w-36 md:h-36 object-contain"
                        />
                    </a>
                ))}
            </SliderCustom>
        </div>
    );
}
